<template>
  <div>
    <modal name="medical-leave" height="auto" @closed="closed">
      <div class="leave-modal">
        <div class="leave-modal-close">
          <a @click="$modal.hide('medical-leave')"> &times; </a>
        </div>
        <div class="px-4 pt-3 px-md-4 modal-head-description d-flex">
          <div class="write-input">
            <h3>{{ $t("leave.create.title") }}</h3>
          </div>
        </div>
        <!-- absence type -->
        <div class="row mt-3">
          <div class="col-sm-6 col-xl-4">
            <p class="pl-4">{{ $t("leave.absenceType") }}</p>
          </div>
          <div class="col-sm-6 col-xl-4 leave-select">
            <div class="form-group">
              <select class="form-control" v-model="leaveType">
                <option value="" selected>
                  {{ $t("leave.absenceType") }}
                </option>
                <option
                  v-for="(type, index) in leaveTypes"
                  :value="type"
                  :key="index"
                >
                  {{ type }}
                </option>
              </select>
              <div class="select-down">
                <img
                  class="select-down__icon"
                  src="@/assets/images/down-arrow.svg"
                  alt="Arrow Icon"
                  aria-hidden="true"
                />
              </div>
              <errors :errors="errors" field="leaveType" />
            </div>
          </div>
        </div>
        <!-- persons -->
        <div class="row">
          <div class="col-sm-6 col-xl-4">
            <p class="pl-4">{{ $t("leave.create.person") }}:</p>
          </div>
          <div class="col-sm-6 col-xl-4 leave-select">
            <div class="form-group">
              <select class="form-control" v-model="employee">
                <option value="" selected>
                  {{ $t("leave.create.person.placeholder") }}
                </option>
                <option
                  v-for="(emp, index) in employees"
                  :value="emp"
                  :key="index"
                >
                  {{ emp.firstName }} {{ emp.lastName }}
                </option>
              </select>
              <div class="select-down">
                <img
                  class="select-down__icon"
                  src="@/assets/images/down-arrow.svg"
                  alt="Arrow Icon"
                  aria-hidden="true"
                />
              </div>
              <errors :errors="errors" field="employee" />
            </div>
          </div>
        </div>

        <!-- start date -->
        <div class="row">
          <div class="col-sm-6 col-xl-5">
            <p class="pl-4 pb-0 mb-0">{{ $t("leave.create.startDate") }}:</p>
            <div class="title-calender-w ml-4 common-filter">
              <div>
                <d-datepicker
                  v-model="fromDate"
                  :placeholder="$t('leave.create.fromDate')"
                  :highlighted="{
                    from: fromDate,
                    to: toDate || new Date(),
                  }"
                  :disabledDates="disabledDatesFrom"
                  @input="checkDates"
                  :language="fr"
                  small
                  typeable
                />
              </div>
            </div>
            <errors class="pl-4" :errors="errors" field="fromDate" />
          </div>
          <div class="col-sm-6 col-xl-4" v-if="fromDate">
            <p class="pb-0 mb-0">
              {{ $t("leave.create.startDateComment") }}:
              {{ formatDate(fromDate) }}
            </p>
            <div class="leave-select">
              <div class="form-group">
                <select class="form-control" v-model="fromHalf">
                  <option :value="false">Toute la journée</option>
                  <option :value="true">Demi-journée</option>
                </select>
                <div class="select-down">
                  <img
                    class="select-down__icon"
                    src="@/assets/images/down-arrow.svg"
                    alt="Arrow Icon"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- end date -->
        <div class="row mt-3">
          <div class="col-sm-6 col-xl-5">
            <p class="pl-4 pb-0 mb-0">{{ $t("leave.create.endDate") }}:</p>
            <div class="title-calender-w ml-4 common-filter">
              <div>
                <d-datepicker
                  v-model="toDate"
                  :highlighted="{
                    from: fromDate,
                    to: toDate || new Date(),
                  }"
                  :disabledDates="disabledDatesTo"
                  :placeholder="$t('leave.create.toDate')"
                  @input="checkDates"
                  :language="fr"
                  small
                  typeable
                ></d-datepicker>
              </div>
            </div>
            <errors class="pl-4" :errors="errors" field="toDate" />
          </div>
          <div class="col-sm-6 col-xl-4" v-if="toDate">
            <p class="pb-0 mb-0">
              {{ $t("leave.create.endDateComment") }}: {{ formatDate(toDate) }}
            </p>
            <div class="leave-select">
              <div class="form-group">
                <select class="form-control" v-model="toHalf">
                  <option :value="false">Toute la journée</option>
                  <option :value="true">Demi-journée</option>
                </select>
                <div class="select-down">
                  <img
                    class="select-down__icon"
                    src="@/assets/images/down-arrow.svg"
                    alt="Arrow Icon"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showCheckMark" class="px-4 form-group form-field-style-2">
          <label class="checkbox-main">
            would u like to continue ?
            <input type="radio" :value="false" v-model="showCheckMark" />
            <span class="checkmark"></span>
          </label>
        </div>

        <!-- note area -->
        <div class="row mt-4">
          <div class="col-sm-12 col-xl-11">
            <p class="pl-4 pb-0 mb-0">{{ $t("leave.create.note") }}</p>
            <div class="pl-4 leave-text-area mt-1">
              <textarea
                :placeholder="$t('leave.create.note.placeholder')"
                v-model="comment"
              >
              </textarea>
            </div>
          </div>
        </div>

        <!-- save btn -->
        <div class="row mt-md-4 mb-md-2" v-if="!showCheckMark">
          <div class="col-sm-12 col-xl-10 leave-modal-save text-right">
            <button v-if="!edit" class="modal-save-btn" @click="saveLeave()">
              {{ $t("global.save") }}
            </button>
            <button v-else class="modal-save-btn" @click="updateLeave()">
              {{ $t("global.update") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import SelectPure from 'select-pure';
import TimeUtils from '../../utils/TimeUtils';
import Errors from '../../components/error/errors.vue';
import ErrorsHelper from '../../helper/ErrorsHelper';
import TaskHelper from '../../helper/TaskHelper';
import { fr } from 'vuejs-datepicker/dist/locale';

export default {
  props: ['bulk'],

  components: {
    Errors,
  },

  mounted() {
    this.currentUser = this.$store.state.user.informations;
    this.fetchEmployees();
    this.$root.$on('medicalLeave', (leave) => {
      this.editLeave(leave);
    });
  },

  data() {
    return {
      leaveTypes: ['Médicale', 'Formation'],
      modalName: 'medical-leave',
      requiredFields: ['leaveType', 'employee', 'fromDate', 'toDate'],
      leaveType: '',
      employees: [],
      employee: '',
      fromHalf: false,
      toHalf: false,
      fromDate: '',
      disabledDatesFrom: {
        to: new Date(),
      },
      toDate: '',
      comment: '',
      errors: {},
      fr,
      edit: false,
      reference: '',
      showCheckMark: false,
    };
  },

  computed: {
    checkDates() {
      if (this.toDate < this.fromDate) {
        this.toDate = null;
      }
      if (
        this.fromDate &&
        this.toDate &&
        this.employee &&
        this.employee.reference
      ) {
        this.validateWithOtherLeave(this.employee.reference);
      }
    },

    disabledDatesTo() {
      return {
        to: this.fromDate || new Date(),
      };
    },
  },

  methods: {
    closed() {
      this.resetFields();
    },

    validateWithOtherLeave(reference) {
      const params = this.dates();
      this.$services.absenceRequest
        .validateLeave(reference, params)
        .then((res) => {
          this.showCheckMark = res.data.length;
        });
    },

    fetchEmployees() {
      this.$services.user.employeeForParticularGroup('/').then((res) => {
        res.data.forEach((emp) => {
          this.employees.push({
            reference: emp.reference,
            firstName: emp.firstName,
            lastName: emp.lastName,
          });
        });
      });
    },

    formatDate(date) {
      return TimeUtils.formatFullDay(date);
    },

    dates() {
      const obj = {};
      obj.to = this.toHalf
        ? TimeUtils.getMiddleOfDay(this.toDate).valueOf()
        : TimeUtils.getEndOfDay(this.toDate).valueOf();

      obj.from = this.fromHalf
        ? TimeUtils.getMiddleOfDay(this.fromDate).valueOf()
        : TimeUtils.getEndOfDay(this.fromDate).valueOf();
      return obj;
    },

    fillLeaveObj() {
      const leaveObj = {
        leaveType: this.leaveType,
        employee: this.employee,
        fromDate: this.dates().from,
        toDate: this.dates().to,
        comment: this.comment,
      };
      return leaveObj;
    },

    validateLeave(leave) {
      this.errors = {};
      return ErrorsHelper.checkErrors(this.requiredFields, leave, this.errors);
    },

    saveLeave() {
      const leave = this.fillLeaveObj();
      if (this.validateLeave(leave)) {
        delete leave.fromDate; // we need object not separate properties
        delete leave.toDate;
        leave.dates = this.dates();
        this.$services.medicalLeave.createLeave(leave).then((res) => {
          if (res.data.reference) {
            this.$modal.hide(this.modalName);
            this.$emit('updateArray', leave);
            this.$miniToastr.success(this.$t('global.saved'));
            this.resetFields();
          } else {
            this.$miniToastr.error(this.$t('global.notSaved'));
          }
        });
      }
    },

    updateLeave() {
      const leave = this.fillLeaveObj();
      if (this.validateLeave(leave)) {
        delete leave.fromDate; // we need object not separate properties
        delete leave.toDate;
        leave.dates = this.dates();
        this.$services.medicalLeave
          .updateLevae(this.reference, leave)
          .then((res) => {
            if (res.status == 200) {
              this.$modal.hide(this.modalName);
              leave.edit = true;
              leave.reference = this.reference;
              this.$emit('updateArray', leave);
              this.$miniToastr.success(this.$t('global.update'));
              this.resetFields();
            } else {
              this.$miniToastr.error(this.$t('global.noUpdate'));
            }
          });
      }
    },

    editLeave(leave) {
      this.edit = true;
      this.leaveType = leave.leaveType;
      this.employee = leave.employee;
      this.fromHalf = !(TimeUtils.isFullDay(leave.dates.from) == 1);
      this.toHalf = !(TimeUtils.isFullDay(leave.dates.to) == 1);
      this.fromDate = new Date(TimeUtils.formatDateForCalander(leave.dates.from));
      this.toDate = new Date(TimeUtils.formatDateForCalander(leave.dates.to));
      this.comment = leave.comment;
      this.reference = leave.reference;
    },

    resetFields() {
      this.leaveType = '';
      this.employee = '';
      this.fromDate = '';
      this.toDate = '';
      this.fromHalf = false;
      this.toHalf = false;
      this.comment = '';
      this.edit = false;
    },
  },
};
</script>
<style lang="scss">
.leave-modal {
  position: relative;
  .title-calender-w {
    width: 200px;
  }
  .leave-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .modal-head-description {
    h3 {
      font-size: 26px;
      font-family: "SF-Pro-Text";
      color: #212529;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 17px;
      }
    }
  }
  .common-filter {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    input {
      background-color: #fff !important;
      border: none !important;
    }
    .icon {
      i {
        padding-left: 7px;
      }
    }
  }
  .leave-select {
    position: relative;
    select {
      background: white !important;
      color: black !important;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4) !important;
      background-repeat: no-repeat;
      -webkit-appearance: none;
      -moz-appearance: none;
      position: relative;
    }
    .select-down {
      position: absolute;
      right: 25px;
      top: 8px;
      &__icon {
        width: 13px;
      }
    }
  }
  .leave-text-area {
    textarea {
      width: 92%;
      height: 120px;
      resize: none;
      outline: none;
      border: 1px solid #becad6;
      border-radius: 4px;
      padding: 15px;
      font-family: "SF-Pro-Text";
    }
  }
  .leave-modal-save {
    .modal-save-btn {
      background-color: #4f78e2;
      padding: 7px 30px;
      display: inline-block;
      border: none;
      color: #fff;
      border-radius: 4px;
      font-family: "SF-Pro-Text";
      outline: none !important;
      @media (min-width: 320px) and (max-width: 600px) {
        margin-top: 20px;
      }
    }
  }
}

.leave-tabel-head {
  tr {
    border-bottom: 1px solid #ddd;
    display: grid;
    grid-template-columns: 20% 20% 20% 20% 20%;
  }
}
.leave-tabel-body {
  tr {
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    display: grid;
    grid-template-columns: 20% 20% 20% 20% 20%;
  }
}
</style>
